import { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { FaFilePdf } from 'react-icons/fa'
import { usePrintSetting } from '../context/print_setting'
import { useAuthState } from '../firebase/hooks'
import { Designed } from '../types'
import { logEvent } from '../utils'

export const PrintButton = ({ ...otherProps }: Designed) => {
  const { user } = useAuthState()
  const [formModalShow, setFormModalShow] = useState(false)
  const [isClickedPrintButton, setIsClickedPrintButton] = useState(false)
  const handleOpen = () => {
    setFormModalShow(true)
  }
  const handleClose = () => {
    setFormModalShow(false)
  }
  const { setPrintSetting, printSetting, print } = usePrintSetting()

  return (
    <>
      <Button
        variant="link"
        onClick={() => {
          handleOpen()
          logEvent('tap_print_setting_button', { uid: user?.uid })
        }}
        {...otherProps}
      >
        <FaFilePdf className="text-muted" />
      </Button>
      <Modal
        show={formModalShow}
        onHide={handleClose}
        onExited={async () => {
          if (isClickedPrintButton) {
            await print()
            logEvent('tap_print_preview_button', {
              uid: user?.uid,
            })
            setIsClickedPrintButton(false)
          }
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="h5">印刷設定</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>カラーモード</Form.Label>
              <div>
                <Form.Check
                  inline
                  type="radio"
                  id="print-monotone"
                  label="モノクロ"
                  checked={printSetting.theme === 'monotone'}
                  onChange={async (e) => {
                    if (e.currentTarget.checked)
                      await setPrintSetting({
                        ...printSetting,
                        theme: 'monotone',
                      })
                  }}
                />
                <Form.Check
                  inline
                  id="print-color"
                  type="radio"
                  label="カラー"
                  checked={printSetting.theme === 'colorful'}
                  onChange={async (e) => {
                    if (e.currentTarget.checked)
                      await setPrintSetting({
                        ...printSetting,
                        theme: 'colorful',
                      })
                  }}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>コメント欄</Form.Label>
              <Form.Check
                type="checkbox"
                id="output-comments"
                label="出力する"
                checked={printSetting.showComments}
                onChange={(e) =>
                  setPrintSetting({
                    ...printSetting,
                    showComments: e.currentTarget.checked,
                  })
                }
              />
              <Form.Text className="text-muted">
                {
                  '※コメントに対する返信を印刷する場合は、当該コメントの下にある返信を表示のボタンを押して、事前に返信を表示しておいてください。'
                }
              </Form.Text>
            </Form.Group>
            <Button
              variant="primary"
              type="button"
              onClick={() => {
                setIsClickedPrintButton(true)
                handleClose()
              }}
            >
              印刷プレビュー
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}
